export default "__VITE_ASSET__CE2cq0TC__"